/* components/patterns/AuthLayout.jsx — адаптивная обёртка гостевой зоны (S12, фикс №41).
   // заменяет: app/layouts/AuthLayout.jsx (фикс. height 920 + grid 1fr/1fr ломал ≤720).
   Окно по центру (max 1240, height:auto). Воронка (/signin,/signup,/forgot,
   /reset-password,/email-sent) → сплит LeftVisual + форма. Утилитарные landing-страницы
   (/invite,/verify-email,/verify-email-change) → одна центрированная колонка без визуала.
   ≤720: LeftVisual скрыт (CSS), форма 100%. Футер — одной строкой; «Поддержка» → Telegram
   @restorium_help; переключатель языка кликабелен → LanguagePicker (поиск по языкам).
   ХЕНДОФФ → frontend/src/components/auth/AuthLayout.jsx. */

import React from 'react';
import { LeftVisual } from './LeftVisual.jsx';
import { LanguagePicker, LANG_NATIVE } from './LanguagePicker.jsx';
import { Icon } from '../ui/Icon.jsx';
import { RR } from '../../lib/router.jsx';

  const { Outlet, useLocation, Link } = RR;
  const { useState } = React;

  // воронка регистрации/входа — с брендовым визуалом; утилитарные — компактные
  const SPLIT_PREFIXES = ['/signin', '/signup', '/forgot', '/reset-password', '/email-sent'];

  function AuthFooter() {
    const [lang, setLang] = useState('ru');
    const [pickerOpen, setPickerOpen] = useState(false);

    return (
      <footer className="auth-foot">
        <span className="auth-foot__copy t-caption">© 2026 Ресториум</span>
        <nav className="auth-foot__links">
          <Link to="/legal/offer" className="auth-foot__link">Условия</Link>
          <Link to="/legal/privacy" className="auth-foot__link">Конфиденциальность</Link>
          <Link to="/help" className="auth-foot__link">Поддержка</Link>
        </nav>
        <button type="button" className="auth-foot__lang" aria-haspopup="dialog"
                onClick={() => setPickerOpen(true)}>
          <Icon name="globe" size={13} />
          <span>{LANG_NATIVE[lang] || 'Русский'}</span>
        </button>
        {pickerOpen && (
          <LanguagePicker
            value={lang}
            onSelect={(l) => { setLang(l); setPickerOpen(false); }}
            onClose={() => setPickerOpen(false)}
          />
        )}
      </footer>
    );
  }

  function AuthLayout() {
    const { pathname } = useLocation();
    const split = SPLIT_PREFIXES.some((p) => pathname === p || pathname.startsWith(p));

    return (
      <div className={'auth-shell' + (split ? ' auth-shell--split' : ' auth-shell--compact')}>
        <div className="auth-shell__bg" aria-hidden="true" />
        <div className="auth-window">
          {/* верхняя панель окна — бренд (как в старом фронте) */}
          <header className="auth-window__top">
            <Link to="/signin" className="auth-window__brand" aria-label="Ресториум">
              <img className="brand-logo" src="/logo-mark.svg" alt="" width={28} height={28} />
              <span className="brand-word">Ресториум</span>
            </Link>
          </header>
          <div className="auth-window__body">
            {split && LeftVisual ? <LeftVisual /> : null}
            <main className="auth-main">
              <div className="auth-main__inner">
                <Outlet />
              </div>
            </main>
          </div>
          {/* футер — общий низ окна (на всю ширину), одной строкой */}
          <AuthFooter />
        </div>
      </div>
    );
  }

export { AuthLayout };
